import React from 'react'
import "./InstallationHelpPageBanner.css"
import "./ResponsiveInstallationHelpPageBanner.css"
const InstallationHelpPageBanner = () => {
    return (
        <>
            {/* <section className='installation-help-page-banner-section'>
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 text-start">
                            <div className='business-parent-dv'>
                                <div className="business-heading text-start">
                                    <img src="/images/help-and-support/heading-bg.png" alt="" />
                                    <h1>Installation Help</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='installation-help-page-banner-section'>
                <div className=" align-items-center">
                    <div className="text-start">
                        <div className="banner-top-img-bg-rel-parent">
                            <div className="banner-top-img-bg-rel">
                                <img src="/images/help-and-support/installation.png" alt="" className='img-fluid banner-img-tag' />
                                <div className="banner-top-content-absol business-heading text-start">
                                    <img src="/images/help-and-support/heading-bg.png" alt="" className='img-fluid' />
                                    <div className='business-banner-heading'>
                                        <div className="container">
                                            <h1>Solar Requirement Form</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InstallationHelpPageBanner